import React from 'react';
import { Spin } from 'antd';
import { Translate } from '../../../services';
import PropTypes from 'prop-types';
import LearningList from '../learningList';
import { useResourceListQuery } from '../../../gql/hooks/queries/useResourcesListQuery';
import './styles.less';

const ResourceList = ( { resourceIds } ) => {

    const { data, loading } = useResourceListQuery( { filter: resourceIds } );

    return (
        <div className='resources'>
            { loading ?
                <Spin /> :
            data.length ?
                <>
                    <h4>
                        <Translate.Text 
                            className="anim-fade-in-fast" 
                            value="page.courseDetails.sections.resources.header" /> 
                    </h4>
                    <LearningList
                        displayType='search'
                        learningType='resource'
                        data={ data }
                        isLoading={ loading }
                    />
                </> :
                <></> }
        </div> );
};

ResourceList.propTypes = {
    resourceIds: PropTypes.arrayOf( PropTypes.string ),
};

ResourceList.defaultProps = {
    resourceIds: [],
};

export default ResourceList;